import {
  INICIALITZAR,
  OBTENIR_INDRETS,
  OBTENIR_INDRETS_LLISTAT,
  OBTENIR_INDRET_ID,
  OBTENIR_DADES_INDRET,
  ESBORRAR_INDRET_SELECCIONAT
} from "../../actions/actionTypes";
import { esObjecteBuit } from "../utils";

const ESTAT_INICIAL = {
  indrets: {},
  llistat: [],
  idIndretSeleccionat: null,
  indretSeleccionat: {}
};

const indretsReducer = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_INDRETS}_EN_CURS`:
    case `${OBTENIR_INDRETS_LLISTAT}_EN_CURS`:
    case `${OBTENIR_DADES_INDRET}_EN_CURS`:
      return {
        ...state
      };

    case `${OBTENIR_INDRETS}_SUCCESS`:
      return {
        ...state,
        indrets: action.payload
      };
    case `${OBTENIR_INDRETS_LLISTAT}_SUCCESS`:
      return {
        ...state,
        llistat: action.payload
      };

    case `${OBTENIR_INDRETS}_ERROR`:
    case `${OBTENIR_INDRETS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_INDRET}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    case `${OBTENIR_DADES_INDRET}_SUCCESS`:
      return {
        ...state,
        indretSeleccionat: action.payload.indret[0]
      };

    case OBTENIR_INDRET_ID:
      return {
        ...state,
        idIndretSeleccionat: action.payload
      };

    case ESBORRAR_INDRET_SELECCIONAT:
      return {
        ...state,
        idIndretSeleccionat: null,
        indretSeleccionat: {}
      };

    default:
      return state;
  }
};

export default indretsReducer;

const esIndretActiu = indret => indret.dataBaixa === null;
const esIndretInactiu = indret => !esIndretActiu(indret);
const getPeticioEnCurs = state => state.peticioEnCurs;
const totsIndrets = state => state.indrets;
const getIndretsPerEstat = (state, estatIndret) => {
  const indrets = getIndrets(state);
  if (!indrets) {
    return null;
  }

  var indretsPerEstat = {};
  Object.keys(indrets).forEach(idIndret => {
    const indret = indrets[idIndret];
    if (estatIndret(indret)) {
      indretsPerEstat[idIndret] = indret;
    }
  });

  return indretsPerEstat;
};

export const getIndrets = state => {
  const indrets = totsIndrets(state);
  if (!indrets) {
    return null;
  }
  return indrets;
};

export const getIndretsLlistat = state => {
  return state.llistat;
};

export const getPeticioIndretsEnCurs = state => {
  const peticioEnCurs = getPeticioEnCurs(state);
  if (typeof peticioEnCurs !== "boolean") {
    return null;
  }
  return peticioEnCurs;
};

export const getPeticioIndretsError = state => state.error;

export const getIndretsPerObservador = (
  observadorsActius,
  indrets,
  idObservadorSeleccionat
) => {
  if (
    !observadorsActius ||
    !indrets ||
    esObjecteBuit(indrets) ||
    !observadorsActius[idObservadorSeleccionat]
  )
    return null;

  const idIndretsObservadorSeleccionat =
    observadorsActius[idObservadorSeleccionat].indrets;
  return idIndretsObservadorSeleccionat.map(idIndret => {
    return { id: idIndret, nom: indrets[idIndret].nom }; // assumim que les dades seràn correctes
  });
};

export const getDadesIndret = state => {
  return state.indretSeleccionat;
};

export const getIdIndret = state => {
  return state.idIndretSeleccionat;
};

export const getIndretPerId = state => {
  const indretsLlistat = state.indrets;
  const indretId = state.idindretSeleccionat;

  return indretsLlistat[indretId];
};

export const getIndretsActius = state => {
  return getIndretsPerEstat(state, esIndretActiu);
};

export const getIndretsInactius = state => {
  return getIndretsPerEstat(state, esIndretInactiu);
};

export const getIndretsAsArray = state => {
  const indretsIndexatsPerId = getIndrets(state);
  return Object.keys(indretsIndexatsPerId).map(idIndret => ({
    ...indretsIndexatsPerId[idIndret],
    id: parseInt(idIndret)
  }));
};
